var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import DatePicker from 'react-datepicker';
import { humanize, titleize, underscored } from 'underscore.string';
import moment from 'moment';
import CustomerSearch from 'components/site/customer-search';
import CargomaticSelect from 'components/v2/select';
import CargomaticInput from 'components/v2/input';
import CargomaticRadio from 'components/v2/forms/Radio';
import DateIconButton from 'components/v2/buttons/DateIconButton';
import { getMaxAdjustmentRate } from 'helpers/order-shipments';
import { isIntermodalShipmentType } from 'helpers/shipment-types';
import AccessorialRequestActionCreators from 'actions/AccessorialRequestActionCreators';
import { getAccessorials } from 'utils/AccessorialWebAPIUtils';
import ToastStore from 'stores/ToastStore';
import { getAccessorialRequestRates } from 'utils/AccessorialRequestWebAPIUtils';
import { Translation, withTranslation } from 'react-i18next';
import formatMoney from 'utils/formatters/Money';
import ViewAccessorialRequestDocumentRequirements from 'components/modules/shipments/accessorials/ViewAccessorialDocumentRequirements';
import { CONFIGURED_FEATURES, featureEnabled } from 'helpers/feature-flags';
import { validDecimal } from 'utils/accounting-util';
import { sluggify } from 'utils/localization/utils';
import { findPaymentPartners } from '../../../../utils/PaymentPartnerWebAPIUtils';
import CargomaticModal from '../../../v2/modal';
import Alert from '../../../ui/Alert';
import CustomerSearchV2 from '../../../site/CustomerSearchFilter';
const DATE_FORMAT = 'L LT';
const SHIPPER = 'shipper';
const CONSIGNEE = 'consignee';
const CARRIER = 'carrier';
const VENDOR = 'vendor';
const PARTNER = 'partner';
const PAYER_COST_FIELD_NAME = 'shipper_cost';
const PAYEE_COST_FIELD_NAME = 'carrier_cost';
const BASE_COST = 'base_cost';
const FSC_TYPE = 'fuel_surcharge';
const FSC_MESSAGE = 'Fuel Surcharge';
const FSC_VALUE_FIELD_NAME = 'value';
const FSC_OVERWRITTEN_RATE_SOURCE = 'overwritten_price_engine';
const MANUAL_RATE_SOURCE = 'manual';
const RECEIVABLES = 'receivables';
const PAYABLES = 'payables';
const adjustmentMessages = {
    invalid_adjustment: 'ADJUSTMENT_MESSAGES_BAND_ADJUSTMENT',
};
function getMomentDate(date) {
    if (!date) {
        return null;
    }
    return moment(date);
}
function isShipper(payeeType) {
    return payeeType === SHIPPER;
}
function isConsignee(payeeType) {
    return payeeType === CONSIGNEE;
}
function isVendor(payeeType) {
    return payeeType === VENDOR;
}
function isCarrier(payeeType) {
    return payeeType === CARRIER;
}
function isPartner(payeeType) {
    return payeeType === PARTNER;
}
function Footer({ footerClassName, onRemove, showRemove, showSave, saveDisabled, onSave, onCancel, total, showTotal, currency, }) {
    const className = classnames('flex items-center flex-wrap', {
        'justify-between': showTotal,
        'justify-end': !showTotal,
    });
    return (React.createElement("div", { className: className },
        showTotal && (React.createElement("p", { className: "my-0 text-xl text-green" }, formatMoney(total, currency))),
        React.createElement("div", { className: footerClassName },
            showRemove && (React.createElement("button", { className: "button btn-danger account-shipment-removeAdjustment heap", onClick: onRemove },
                React.createElement(Translation, null, (t) => titleize(t('REMOVE'))))),
            React.createElement("div", { className: "form-actions" },
                showSave ? (React.createElement("button", { className: "mr-2 button button-green account-addInternalAdjustmentModal-addAdjustment heap", onClick: onSave, disabled: saveDisabled, "data-testid": "addAdjustment_saveButton" },
                    React.createElement(Translation, null, (t) => titleize(t('SAVE'))))) : (React.createElement("button", { className: "mr-2 button button-green account-addInternalAdjustmentModal-addAdjustment heap", onClick: onSave, disabled: saveDisabled, "data-testid": "addAdjustment_saveButton" },
                    React.createElement(Translation, null, (t) => t('CREATE_ACCESSORIAL_REQUEST')))),
                React.createElement("button", { className: "button button-secondary", onClick: onCancel, "data-testid": "addAdjustment_cancelButton" },
                    React.createElement(Translation, null, (t) => t('CANCEL')))))));
}
class AddOrAdjustDrayageAccessorialModal extends Component {
    constructor(props) {
        super(props);
        this.fetchAccessorialRequestRate = () => {
            const { shipment: { carrier, consignee, shipper, shipment_id: shipmentId, shipment_type: shipmentType, }, } = this.props;
            const { payer_type, payee_type: userType, vendor, type, partner, } = this.state;
            if (!type) {
                return;
            }
            let payerRequest;
            const isConsigneeSet = isConsignee(payer_type) && consignee;
            if (isConsigneeSet) {
                payerRequest = {
                    slug: type,
                    customer: consignee._id,
                    userType: CONSIGNEE,
                    shipmentId,
                    shipmentType,
                };
            }
            else {
                payerRequest = {
                    slug: type,
                    customer: shipper._id,
                    userType: SHIPPER,
                    shipmentId,
                    shipmentType,
                };
            }
            const requests = [payerRequest];
            const isVendorPayee = isVendor(userType);
            const isVendorSet = isVendorPayee && vendor;
            const isPartnerSet = isPartner(userType) && partner;
            const isCarrierSet = isCarrier(userType) && carrier;
            if (isCarrierSet || isVendorSet || isPartnerSet) {
                let customer;
                if (isVendorSet) {
                    customer = vendor;
                }
                else if (isPartnerSet) {
                    customer = partner;
                }
                else {
                    customer = carrier._id;
                }
                requests.push({
                    slug: type,
                    customer,
                    userType,
                    shipmentId,
                    shipmentType,
                });
            }
            this.setState({
                ratesRequestPending: true,
            }, async () => {
                const { t } = this.props;
                try {
                    const { entity: { results }, } = await getAccessorialRequestRates(requests);
                    const payerRate = results.find((r) => isShipper(r.userType) && r.accessorial === type);
                    const updates = {
                        ratesRequestPending: false,
                    };
                    // We use the same slot for both the carrier and vendor
                    const payeeRate = results.find((r) => r.userType === userType && r.accessorial === type);
                    if (payeeRate && payeeRate.rates.length > 0) {
                        updates.hasPayeeRate = true;
                        updates.carrier_cost = payeeRate.rates[0].costPerUnit;
                    }
                    else {
                        updates.hasPayeeRate = false;
                        updates.carrier_cost = '';
                    }
                    if (payerRate && payerRate.rates.length > 0) {
                        updates.hasPayerRate = true;
                        updates.shipper_cost = payerRate.rates[0].costPerUnit;
                    }
                    else {
                        updates.hasPayerRate = false;
                        updates.shipper_cost = '';
                    }
                    this.setState(updates);
                }
                catch (e) {
                    ToastStore.addNotification({
                        title: t('PROBLEM_FETCHING_COSTS'),
                        message: e.message,
                        level: 'error',
                    });
                    this.setState({ ratesRequestPending: false });
                }
            });
        };
        this.fetchAccessorials = async () => {
            const { t } = this.props;
            try {
                const result = await getAccessorials({ paginate: false });
                const { entity: { items }, } = result;
                const accessorials = items.map((a) => (Object.assign(Object.assign({}, a), { slug: a.slug || underscored(a.name.toLowerCase()) })));
                this.setState({
                    accessorials,
                });
            }
            catch (e) {
                ToastStore.addNotification({
                    title: t('LOADING_ACCESSORIALS_ERROR'),
                    body: e.message,
                    level: 'error',
                });
            }
        };
        this.handleVendorFieldChange = (value) => {
            this.setState({
                vendor_name: value,
                vendor: null,
            });
        };
        this.handleVendorSelect = (_value, item) => {
            this.setState({
                vendor_name: item.company_name,
                vendor: item._id,
            }, () => this.fetchAccessorialRequestRate());
        };
        this.handlePartnerFieldChange = (value) => {
            this.setState({
                partner_name: value,
                partner: null,
            });
        };
        this.handlePartnerSelect = (_value, item) => {
            this.setState({
                partner_name: item.name,
                partner: item._id,
            }, () => this.fetchAccessorialRequestRate());
        };
        this.handleAccessorialSelect = (e) => {
            const accessorialType = e.target.value;
            const dateTime = {
                begin_date: null,
                end_date: null,
                begin_time: null,
                end_time: null,
            };
            this.setState((prevState) => {
                if (!accessorialType) {
                    return Object.assign(Object.assign({ type: accessorialType }, dateTime), { disableAddAdjustment: false });
                }
                if (accessorialType !== 'other') {
                    const accessorial = prevState.accessorials.find((s) => s.slug === accessorialType);
                    const name = accessorial ? accessorial.name : accessorialType;
                    return Object.assign(Object.assign({ name, type: accessorialType, unit_name: accessorial.unit, charge_code: accessorial.charge_code, accessorial, error: {} }, dateTime), { disableAddAdjustment: true });
                }
                return Object.assign(Object.assign({ type: accessorialType, unit_name: 'flat', error: {} }, dateTime), { disableAddAdjustment: true });
            }, () => this.fetchAccessorialRequestRate());
        };
        this.handleClose = () => {
            this.setState(this.getInitialState());
            this.props.onHide();
        };
        this.handleRemoveAdjustment = () => {
            const { _id, ledger } = this.state;
            this.props.onRemoveAdjustment({
                _id,
                ledger,
            });
            this.handleClose();
        };
        this.handleCustomerApprovalChanges = (required, provided) => {
            this.setState({
                customerApprovalRequired: required,
                customerApprovalProvided: provided,
            });
        };
        this.handleUpdateAccessorialRequiredDocs = (bool) => {
            this.setState({ accessorialRequiredDocsReturned: bool });
        };
        this.handleSave = () => {
            const { error, fscError } = this.validate();
            const { existing, processed, category } = this.state;
            if (Object.keys(error).length > 0 || Object.keys(fscError).length > 0) {
                this.setState({ error, fscError });
            }
            else if (existing &&
                !processed &&
                (category === 'accessorials' || category === 'base_cost')) {
                this.props.onEditAdjustment(this.generateUpdatedAdjustments());
                this.handleClose();
            }
            else if (existing &&
                processed &&
                this.state.existingUnprocessedBaseCostAdjustment &&
                category === 'base_cost') {
                this.props.onEditAdjustment(this.updateExistingAdjustments());
                this.handleClose();
            }
            else {
                this.props.onSave(this.convertToAdjustments());
                this.setState(this.getInitialState());
            }
        };
        this.handleCreateAccessorialRequest = () => {
            var _a, _b, _c, _d, _e, _f, _g;
            const { error } = this.validate(true);
            const { shipment } = this.props;
            if (Object.keys(error).length > 0) {
                return this.setState({ error });
            }
            const { carrier_cost, shipper_cost, carrier_unit_qty, shipper_unit_qty, description, begin_date, end_date, payer_type, payee_type, vendor_name, vendor, partner, partner_name, location, note, equipment, name, type, unit_name, charge_code, customerApprovalRequired, customerApprovalProvided, } = this.state;
            const payerCost = parseFloat(shipper_cost)
                ? parseFloat(shipper_cost).toFixed(2)
                : shipper_cost;
            const payeeCost = parseFloat(carrier_cost)
                ? parseFloat(carrier_cost).toFixed(2)
                : carrier_cost;
            const shipment_id = shipment === null || shipment === void 0 ? void 0 : shipment.shipment_id;
            const carrier = (_a = shipment === null || shipment === void 0 ? void 0 : shipment.carrier) === null || _a === void 0 ? void 0 : _a._id;
            const carrier_name = (_b = shipment === null || shipment === void 0 ? void 0 : shipment.carrier) === null || _b === void 0 ? void 0 : _b.name;
            const shipper = (_c = shipment === null || shipment === void 0 ? void 0 : shipment.shipper) === null || _c === void 0 ? void 0 : _c._id;
            const shipper_name = (_d = shipment === null || shipment === void 0 ? void 0 : shipment.shipper) === null || _d === void 0 ? void 0 : _d.company_name;
            const consignee = (_e = shipment === null || shipment === void 0 ? void 0 : shipment.consignee) === null || _e === void 0 ? void 0 : _e._id;
            const accessorial = {
                shipper_rate: payerCost,
                carrier_rate: payeeCost,
                carrier_unit_qty,
                shipper_unit_qty,
                description,
                begin_datetime: begin_date,
                end_datetime: end_date,
                location,
                note: note || '',
                shipper_note: note || '',
                carrier_note: note || '',
                equipment: equipment ? [equipment] : [],
                message: name,
                accessorial_type: type,
                type: 'accessorial',
                exception_type: 'Accessorial Request',
                shipment: shipment._id,
                carrier,
                carrier_name,
                shipper,
                shipper_name,
                payer_type,
                payee_type,
                consignee,
                vendor_name,
                vendor,
                partner,
                partner_name,
                shipment_id,
                shipper_status: 'pending-shipper',
                carrier_status: 'pending-admin',
                unit_name,
                charge_code,
            };
            if (featureEnabled(CONFIGURED_FEATURES.SSR)) {
                if (customerApprovalRequired) {
                    if (customerApprovalProvided) {
                        accessorial.customer_approval_provided = true;
                    }
                    else {
                        accessorial.customer_approval_provided = false;
                    }
                }
            }
            if ((_g = (_f = shipment === null || shipment === void 0 ? void 0 : shipment.timeline) === null || _f === void 0 ? void 0 : _f.job_closed) === null || _g === void 0 ? void 0 : _g.at)
                accessorial.job_closed_date = shipment.timeline.job_closed.at;
            AccessorialRequestActionCreators.bulkCreateAccessorialRequests([
                accessorial,
            ]);
            this.handleClose();
        };
        this.convertAccessorialDateTimes = () => {
            let begin_datetime;
            let end_datetime;
            const { begin_date, begin_time, end_date, end_time } = this.state;
            if (begin_date) {
                if (begin_time) {
                    begin_datetime = combineDateTime(begin_date, begin_time);
                }
                else {
                    begin_datetime = begin_date;
                }
            }
            if (end_date) {
                if (end_time) {
                    end_datetime = combineDateTime(end_date, end_time);
                }
                else {
                    end_datetime = end_date;
                }
            }
            return {
                begin_datetime,
                end_datetime,
                appointment: !!(begin_time || end_time),
            };
        };
        this.handleDateTimeSelect = (id) => {
            return (datetime) => {
                this.setState({ [id]: datetime });
            };
        };
        this.handleNameChange = (name) => {
            const { t } = this.props;
            const { errors } = this.state;
            let value = name;
            if (!value)
                value = '';
            if (value.trim() === '') {
                errors.accessorialName = {
                    message: t('SPECIFY_ACCESSORIAL_NAME'),
                };
            }
            this.setState({ errors, name: value });
        };
        this.handlePayerTypeChange = (payer_type) => {
            this.setState({ payer_type });
        };
        this.handlePayeeTypeChange = (payee_type) => {
            const updates = {
                payee_type,
            };
            if (isCarrier(payee_type)) {
                updates.vendor_name = '';
                updates.vendor = null;
            }
            else {
                // We want to disable the vendor rate field until the user selects a vendor.
                updates.ratesRequestPending = true;
            }
            this.setState(updates);
        };
        this.handleFieldChange = (field, value) => {
            const { errors } = this.state;
            const numericFields = [PAYEE_COST_FIELD_NAME, PAYER_COST_FIELD_NAME];
            if (numericFields.includes(field)) {
                const numericValue = value ? parseFloat(value, 10) : null;
                this.setState({ [field]: numericValue }, this.validateAdjustmentValue);
            }
            else if (field === FSC_VALUE_FIELD_NAME) {
                const numericValue = value ? parseFloat(value, 10) : null;
                this.setState({ [field]: numericValue });
            }
            else {
                this.setState({ errors, [field]: value });
            }
        };
        this.handleFscValueChange = (value) => {
            this.setState((prevState) => {
                const { existingFsc } = prevState;
                const numericValue = value ? parseFloat(value, 10) : null;
                existingFsc.value = numericValue;
                existingFsc.unit_value = numericValue;
                return { existingFsc };
            });
        };
        this.handleAdjustmentReason = (reason) => {
            const { t } = this.props;
            const { errors, existing } = this.state;
            let adjustmentReasonCode = '';
            if (existing) {
                if (reason && reason !== '') {
                    adjustmentReasonCode = reason;
                    errors.adjustmentReason = {};
                }
                else {
                    errors.adjustmentReason = {
                        message: t('PROVIDE_REASON_FOR_ADJUSTMENT'),
                    };
                }
                this.setState({ adjustmentReasonCode, errors });
            }
        };
        this.handleFscAdjustmentReason = (reason) => {
            const { t } = this.props;
            const { errors } = this.state;
            let fscAdjustmentReason = '';
            if (reason && reason !== '') {
                fscAdjustmentReason = reason;
                errors.fscAdjustmentReason = {};
            }
            else {
                errors.fscAdjustmentReason = {
                    message: t('PROVIDE_REASON_FOR_ADJUSTMENT'),
                };
            }
            this.setState({ fscAdjustmentReason, errors });
        };
        this.handleLocationChange = (item) => {
            const { value } = item;
            this.setState({ location: value });
        };
        this.handleValueChange = (field) => (value) => {
            this.setState({ [field]: value });
        };
        this.handleDateValueChange = (field) => (value) => {
            this.setState({ [field]: value.toDate() });
        };
        this.handleNotesField = (note) => {
            this.setState({ note });
        };
        this.handlePayerUnitsField = (shipper_unit_qty) => {
            if (validDecimal(shipper_unit_qty))
                this.setState({ shipper_unit_qty });
        };
        this.handlePayeeUnitsField = (carrier_unit_qty) => {
            if (validDecimal(carrier_unit_qty))
                this.setState({ carrier_unit_qty });
        };
        this.handleProcessingDocumentUpload = (isUploading) => {
            this.setState({ isDocUploadProcessing: isUploading });
        };
        this.renderRemoveButton = () => {
            const { customAdjustment, shipment } = this.props;
            if (shipment && customAdjustment) {
                const adjustmentIsProcessed = customAdjustment.processed;
                // TODO should revisit this one
                const adjustmentViaEDI = customAdjustment.charge_id || customAdjustment.charge_code;
                const isBaseCost = customAdjustment.category === 'base_cost' &&
                    customAdjustment.type !== 'accessorial';
                const isIntermodalBaseCost = isIntermodalShipmentType(shipment) && isBaseCost;
                return (!adjustmentIsProcessed && !adjustmentViaEDI && !isIntermodalBaseCost);
            }
            return true;
        };
        this.state = this.getInitialState();
    }
    componentDidMount() {
        this.fetchData(this.props);
    }
    isSaveButtonDisabled() {
        const { ratesRequestPending, isAdjustment, isDocUploadProcessing, accessorialRequiredDocsReturned, } = this.state;
        if (isDocUploadProcessing) {
            return isDocUploadProcessing;
        }
        if (isAdjustment) {
            if (this.state.disableAddAdjustment) {
                return true;
            }
            return false;
        }
        if (featureEnabled(CONFIGURED_FEATURES.SSR)) {
            if (!accessorialRequiredDocsReturned) {
                return true;
            }
        }
        return ratesRequestPending;
    }
    isPayeeCostDisabled() {
        const { hasPayeeRate, ratesRequestPending } = this.state;
        return hasPayeeRate || hasPayeeRate === null || ratesRequestPending;
    }
    isPayerCostDisabled() {
        const { hasPayerRate, ratesRequestPending } = this.state;
        return hasPayerRate || hasPayerRate === null || ratesRequestPending;
    }
    getInitialState() {
        return {
            name: '',
            vendor_name: '',
            vendor: null,
            partner_name: '',
            partner: null,
            type: '',
            payee_type: CARRIER,
            payer_type: SHIPPER,
            equipment: '',
            shipper_cost: 0,
            carrier_cost: 0,
            error: {},
            location: '',
            ledger: '',
            _id: '',
            category: '',
            note: '',
            shipper_unit_qty: 1,
            carrier_unit_qty: 1,
            unit_name: '',
            custom_description: '',
            begin_date: null,
            end_date: null,
            begin_time: null,
            end_time: null,
            description: null,
            processed: false,
            accessorial: null,
            existing: false,
            isValidAdjustment: true,
            renderWarning: false,
            adjustmentReasonCode: '',
            errors: {
                adjustmentReason: {},
                accessorialName: {},
            },
            accessorials: [],
            isAdjustment: false,
            ratesRequestPending: null,
            hasPayeeRate: null,
            hasPayerRate: null,
            isDocUploadProcessing: false,
            existingFsc: null,
            fscAdjustmentReason: '',
            customerApprovalRequired: false,
            customerApprovalProvided: false,
            accessorialRequiredDocsReturned: true,
        };
    }
    fetchData(props) {
        var _a;
        const { customAdjustment, equipment } = props;
        this.fetchAccessorials();
        // Set the accessorial request payee type to Vendor if the shipment does not have a carrier
        // Only check when the modal opens.
        if (!customAdjustment && !((_a = props.shipment) === null || _a === void 0 ? void 0 : _a.carrier)) {
            this.setState({ payee_type: VENDOR });
        }
        const { t } = this.props;
        const isFscType = customAdjustment && customAdjustment.type === FSC_TYPE;
        if (props.show && customAdjustment && !isFscType) {
            this.setState((prevState) => {
                if (!equipment || equipment.length === 0) {
                    return {
                        error: Object.assign(Object.assign({}, prevState.error), { equipment: t('ADD_EQUIPMENT_TO_SHIPMENT_TO_CREATE_ACCESSORIAL') }),
                    };
                }
                const _a = prevState.error, { equipment: _ } = _a, restError = __rest(_a, ["equipment"]);
                return {
                    error: restError,
                };
            });
        }
        if (props.show && customAdjustment) {
            const adjustment = {
                name: customAdjustment.message,
                equipment: customAdjustment.equipment,
                type: customAdjustment.type,
                begin_date: customAdjustment.begin_date,
                begin_time: customAdjustment.begin_time,
                end_date: customAdjustment.end_date,
                end_time: customAdjustment.end_time,
                location: customAdjustment.location,
                custom_description: customAdjustment.custom_description,
                processed: customAdjustment.processed,
                ledger: customAdjustment.ledger,
                shipper_unit_qty: customAdjustment.shipper_unit_qty || 1,
                carrier_unit_qty: customAdjustment.carrier_unit_qty || 1,
                existing: true,
                _id: customAdjustment._id,
                category: customAdjustment.category,
                rate_source: customAdjustment.rate_source,
            };
            if (customAdjustment.type === FSC_TYPE) {
                // no need to invert value for FSC
                adjustment.value = (customAdjustment === null || customAdjustment === void 0 ? void 0 : customAdjustment.parent_adjustment_id)
                    ? customAdjustment.value
                    : Math.abs(customAdjustment.value);
            }
            else if (customAdjustment.ledger === RECEIVABLES) {
                adjustment.shipper_cost = Math.abs(customAdjustment.value);
            }
            else if (customAdjustment.ledger === PAYABLES) {
                adjustment.carrier_cost = (customAdjustment === null || customAdjustment === void 0 ? void 0 : customAdjustment.parent_adjustment_id)
                    ? customAdjustment.value
                    : Math.abs(customAdjustment.value);
            }
            // Look for an existing unprocessed adjustment
            const baseCostType = customAdjustment.ledger === RECEIVABLES
                ? 'Shipper Cost'
                : 'Carrier Cost';
            const existingUnprocessedBaseCostAdjustment = (this.props.shipment[customAdjustment.ledger] || []).find((l) => !l.processed &&
                (l.category === 'accessorials' || l.category === 'base_cost') &&
                l.message &&
                l.message.includes(`${baseCostType} Adjustment`));
            // look for automated FSC to adjust along with the cost
            const existingFsc = (this.props.shipment[customAdjustment.ledger] || []).find((l) => l.type === FSC_TYPE &&
                !l.accessorial_request_id &&
                l._id !== customAdjustment._id &&
                !customAdjustment.processed &&
                !l.processed &&
                l.rate_source &&
                l.rate_source !== MANUAL_RATE_SOURCE &&
                !(customAdjustment === null || customAdjustment === void 0 ? void 0 : customAdjustment.parent_adjustment_id) &&
                !(l === null || l === void 0 ? void 0 : l.parent_adjustment_id));
            this.setState((prevState) => {
                const accessorial = prevState.accessorials.find((a) => a.slug === adjustment.type);
                let unit_name = '';
                if (accessorial) {
                    unit_name = accessorial.unit;
                }
                const { distance_in_miles } = props.shipment;
                return Object.assign(Object.assign({}, adjustment), { existingUnprocessedBaseCostAdjustment,
                    unit_name,
                    accessorial,
                    distance_in_miles, isAdjustment: true, // used for rendering in shipment accounting section
                    existingFsc });
            });
        }
        else if (equipment.length === 1) {
            this.setState({ equipment: equipment[0]._id });
        }
    }
    convertToAdjustments() {
        const { name, type: accessorialType, adjustmentReasonCode: reason, shipper_cost, carrier_cost, equipment, custom_description, location, begin_date, begin_time, end_date, end_time, processed, 
        // fsc value
        value, } = this.state;
        const { customAdjustment, shipment } = this.props;
        const adjustments = [];
        const type = accessorialType !== 'other' ? accessorialType : 'customer_adjustment';
        const adjustment = {
            message: name,
            type,
            custom_description,
            location,
            begin_date,
            begin_time,
            end_date,
            end_time,
            reason,
        };
        const message = generateCustomAdjustmentMessage(adjustment);
        if (shipper_cost) {
            adjustments.push({
                adjustment: Object.assign({ adjustedItem: 'base_cost', category: 'base_cost', message: getCostLabel(message, RECEIVABLES), value: shipper_cost !== 0 ? shipper_cost.toFixed(2) : shipper_cost, type,
                    reason,
                    equipment,
                    custom_description,
                    location }, this.convertAccessorialDateTimes()),
                ledger: RECEIVABLES,
            });
        }
        if (carrier_cost) {
            const currentBaseCostValue = -getCurrentBaseCostTotal(shipment[customAdjustment.ledger], Math.abs(customAdjustment === null || customAdjustment === void 0 ? void 0 : customAdjustment.value) || 0);
            adjustments.push({
                adjustment: Object.assign({ adjustedItem: 'base_cost', category: 'base_cost', message: getCostLabel(message, PAYABLES), value: carrier_cost !== 0
                        ? getBaseCostAdjustmentTotal(currentBaseCostValue, carrier_cost).toFixed(2)
                        : carrier_cost, type,
                    reason,
                    equipment,
                    custom_description,
                    location }, this.convertAccessorialDateTimes()),
                ledger: PAYABLES,
            });
        }
        if (accessorialType === 'fuel_surcharge' && processed) {
            const currentFscValue = -getCurrentBaseCostTotal(shipment[customAdjustment.ledger], Math.abs(customAdjustment === null || customAdjustment === void 0 ? void 0 : customAdjustment.value) || 0);
            const fscValue = getBaseCostAdjustmentTotal(currentFscValue, value).toFixed(2);
            adjustments.push({
                adjustment: Object.assign({ category: 'accessorials', message: 'Fuel Surcharge adjustment', value: fscValue, type,
                    reason,
                    equipment,
                    custom_description,
                    location }, this.convertAccessorialDateTimes()),
                ledger: customAdjustment.ledger,
            });
        }
        return adjustments;
    }
    generateUpdatedAdjustments() {
        const { name, type, shipper_cost, carrier_cost, begin_date, begin_time, end_date, end_time, custom_description, location, ledger, _id, equipment, adjustmentReasonCode: reason, value, existingFsc, fscAdjustmentReason, } = this.state;
        const initialAdjustment = {
            type,
            message: name,
            begin_date,
            begin_time,
            end_date,
            end_time,
            custom_description,
            location,
            reason,
        };
        const message = generateCustomAdjustmentMessage(initialAdjustment);
        let updatedValue;
        if (type === FSC_TYPE) {
            updatedValue = value;
        }
        else if (shipper_cost) {
            updatedValue = shipper_cost !== 0 ? shipper_cost.toFixed(2) : value;
        }
        else {
            updatedValue = carrier_cost !== 0 ? carrier_cost.toFixed(2) : value;
        }
        updatedValue = updatedValue || 0;
        const rateSource = this.state.rate_source && this.state.rate_source !== MANUAL_RATE_SOURCE
            ? FSC_OVERWRITTEN_RATE_SOURCE
            : MANUAL_RATE_SOURCE;
        const adjustmentToUpdate = [
            Object.assign(Object.assign(Object.assign({ _id,
                ledger,
                location,
                custom_description }, (equipment ? { equipment } : {})), { value: updatedValue, message,
                reason, rate_source: rateSource, timestamp: new Date() }), this.convertAccessorialDateTimes()),
        ];
        if (type === FSC_TYPE) {
            adjustmentToUpdate[0].unit_value = updatedValue;
        }
        if (existingFsc) {
            const rateSource = existingFsc.rate_source &&
                existingFsc.rate_source !== MANUAL_RATE_SOURCE
                ? FSC_OVERWRITTEN_RATE_SOURCE
                : MANUAL_RATE_SOURCE;
            adjustmentToUpdate.push(Object.assign(Object.assign({}, existingFsc), { ledger, rate_source: rateSource, has_pending_state: false, message: FSC_MESSAGE, reason: fscAdjustmentReason, timestamp: new Date() }));
        }
        return adjustmentToUpdate;
    }
    updateExistingAdjustments() {
        const { customAdjustment, shipment } = this.props;
        const { ledger, shipper_cost, carrier_cost, existingUnprocessedBaseCostAdjustment: { _id, message, reason }, } = this.state;
        const newValue = ledger === RECEIVABLES ? shipper_cost : carrier_cost;
        let baseCostValue = (customAdjustment === null || customAdjustment === void 0 ? void 0 : customAdjustment.value) || 0;
        if (ledger === PAYABLES) {
            baseCostValue = -getCurrentBaseCostTotal(shipment[customAdjustment.ledger], Math.abs(customAdjustment === null || customAdjustment === void 0 ? void 0 : customAdjustment.value) || 0);
        }
        const value = getBaseCostAdjustmentTotal(baseCostValue, newValue).toFixed(2);
        return Object.assign({ _id,
            ledger,
            message,
            reason,
            value, timestamp: new Date() }, this.convertAccessorialDateTimes());
    }
    validate(create) {
        var _a, _b;
        const { name, equipment, type, accessorial, begin_date, end_date, location, description, custom_description, adjustmentReasonCode, existing, shipper_unit_qty, carrier_unit_qty, payer_type, payee_type, vendor, partner, shipper_cost, existingFsc, fscAdjustmentReason, ledger, 
        //fsc value
        value, } = this.state;
        const { shipment, customAdjustment, t } = this.props;
        const error = {};
        const fscError = {};
        const consignee = shipment === null || shipment === void 0 ? void 0 : shipment.consignee;
        const carrier = shipment === null || shipment === void 0 ? void 0 : shipment.carrier;
        if (isConsignee(payer_type) && !consignee) {
            error.consignee = t('DRAYAGE_ACCESSORIAL_MODAL_CONSIGNEE_ERROR');
        }
        if (shipper_unit_qty <= 0) {
            error.shipper_unit_qty = t('DRAYAGE_ACCESSORIAL_MODAL_PAYER_UNITS_ERROR');
        }
        if (carrier_unit_qty <= 0) {
            error.carrier_unit_qty = t('DRAYAGE_ACCESSORIAL_MODAL_PAYEE_UNITS_ERROR');
        }
        let parsedShipperCost = parseFloat(shipper_cost);
        if ((!parsedShipperCost && parsedShipperCost !== 0) ||
            parsedShipperCost < 0) {
            error.shipper_cost =
                ((_b = (_a = this.props) === null || _a === void 0 ? void 0 : _a.customAdjustment) === null || _b === void 0 ? void 0 : _b.ledger) === RECEIVABLES
                    ? t('DRAYAGE_ACCESSORIAL_MODAL_SHIPPER_AMOUNT_ERROR')
                    : t('DRAYAGE_ACCESSORIAL_MODAL_PAYER_RATE_ERROR');
        }
        if (parseFloat(value || 0) < 0 && ledger === RECEIVABLES) {
            error.shipper_cost = t('NEGATIVE_ADJUSTMENT_VALUE_NOT_ALLOWED_FOR_SHIPPER_FSC');
        }
        if (!create &&
            (customAdjustment === null || customAdjustment === void 0 ? void 0 : customAdjustment.hasInvoice) &&
            (customAdjustment === null || customAdjustment === void 0 ? void 0 : customAdjustment.charge_code) === 'FSC' &&
            ledger === RECEIVABLES) {
            let baseCostValue = (customAdjustment === null || customAdjustment === void 0 ? void 0 : customAdjustment.value) || 0;
            const newValue = getBaseCostAdjustmentTotal(baseCostValue, value || 0).toFixed(2);
            if (newValue < 0) {
                error.shipper_cost = t('NEGATIVE_ADJUSTMENT_VALUE_NOT_ALLOWED_FOR_SHIPPER_FSC');
            }
        }
        if (!type) {
            error.type = t('DRAYAGE_ACCESSORIAL_MODAL_ACCESSORIAL_TYPE_ERROR');
        }
        if (!name) {
            error.name = t('DRAYAGE_ACCESSORIAL_MODAL_ACCESSORIAL_NAME_ERROR');
        }
        if (!equipment && shipment.order_type !== 'export' && type !== FSC_TYPE) {
            error.equipment = t('DRAYAGE_ACCESSORIAL_MODAL_EQUIPMENT_ERROR');
        }
        if (isVendor(payee_type) && !vendor) {
            error.vendor = t('SELECT_VENDOR');
        }
        else if (create && isPartner(payee_type) && !partner) {
            error.partner = t('SELECT_PARTNER');
        }
        else if (create && isCarrier(payee_type) && !carrier) {
            error.carrier = t('ASSIGN_CARRIER_TO_SHIPMENT.');
        }
        if (type && type === 'wait_time') {
            if (!shipper_unit_qty || !parseFloat(shipper_unit_qty)) {
                error.shipper_unit_qty = t('DRAYAGE_ACCESSORIAL_MODAL_SHIPPER_UNIT_ERROR');
            }
            if (!carrier_unit_qty || !parseFloat(carrier_unit_qty)) {
                error.carrier_unit_qty = t('DRAYAGE_ACCESSORIAL_MODAL_CARRIER_UNIT_ERROR');
            }
        }
        else if (type) {
            if (!shipper_unit_qty || !parseFloat(shipper_unit_qty)) {
                error.shipper_unit_qty = t('DRAYAGE_ACCESSORIAL_MODAL_SHIPPER_UNIT_ERROR');
            }
            if (!carrier_unit_qty || !parseFloat(carrier_unit_qty)) {
                error.carrier_unit_qty = t('DRAYAGE_ACCESSORIAL_MODAL_CARRIER_UNIT_ERROR');
            }
        }
        if (accessorial && accessorial.begin_date_required && !begin_date) {
            error.begin_date = t('REQUIRED_BEGIN_DATE');
        }
        if (accessorial && accessorial.end_date_required && !end_date) {
            error.end_date = t('REQUIRED_END_DATE');
        }
        if (accessorial &&
            accessorial.description_required &&
            !custom_description &&
            !description) {
            error.description = t('REQUIRED_DESCRIPTION');
        }
        if (accessorial && accessorial.location_required && !location) {
            error.location = t('REQUIRED_LOCATION');
        }
        if (existing) {
            if (!adjustmentReasonCode || adjustmentReasonCode.trim() === '') {
                error.adjustmentReasonCode = t('ADJUSTMENT_REASON_ERROR');
            }
        }
        if (existingFsc) {
            if (!fscAdjustmentReason || fscAdjustmentReason.trim() === '') {
                fscError.adjustmentReasonCode = t('ADJUSTMENT_REASON_ERROR');
            }
        }
        return { error, fscError };
    }
    validateAdjustmentValue() {
        let costPerMile = 0.0;
        const { customAdjustment } = this.props;
        if (!customAdjustment) {
            return;
        }
        const { distance_in_miles } = this.state;
        const positiveTotal = customAdjustment.total > 0;
        if (customAdjustment) {
            if (customAdjustment.ledger === PAYABLES) {
                costPerMile = this.state.carrier_cost
                    ? parseFloat(this.state.carrier_cost) / distance_in_miles
                    : 0;
            }
            else if (customAdjustment.ledger === RECEIVABLES) {
                costPerMile = this.state.shipper_cost
                    ? parseFloat(this.state.shipper_cost) / distance_in_miles
                    : 0;
            }
        }
        if (positiveTotal &&
            costPerMile > getMaxAdjustmentRate(distance_in_miles)) {
            this.setState({
                warning: 'invalid_adjustment',
                disableAddAdjustment: true,
                renderWarning: true,
            });
        }
        else {
            this.setState({
                warning: null,
                disableAddAdjustment: false,
                renderWarning: false,
            });
        }
    }
    renderAdjustmentWarning() {
        const { t } = this.props;
        if (!this.state.renderWarning)
            return null;
        const { warning } = this.state;
        const disableAdjustment = warning === 'invalid_adjustment';
        const type = disableAdjustment ? 'error' : 'warning';
        return (React.createElement(Alert, { className: "mb-4", type: type }, t(adjustmentMessages[warning])));
    }
    renderErrors(error = {}) {
        const errorKeys = Object.keys(error);
        if (errorKeys.length === 0) {
            return null;
        }
        const { t } = this.props;
        return (React.createElement(Alert, { type: "error" },
            React.createElement("ul", { className: "m-0" }, errorKeys.map((key) => (React.createElement("li", { className: "mb-2", key: key }, t(error[key])))))));
    }
    renderDropdown() {
        const { t } = this.props;
        const { type } = this.state;
        return (React.createElement("div", { className: "mb-4" },
            React.createElement("select", { className: "form-select", value: type, disabled: this.props.customAdjustment, onChange: this.handleAccessorialSelect },
                React.createElement("option", { value: "" }, t('SELECT_ACCESSORIAL_TYPE')),
                this.state.accessorials
                    .filter((acc) => acc.slug !== 'other')
                    .map((accessorial) => (React.createElement("option", { key: accessorial.slug, value: accessorial.slug }, accessorial.name))))));
    }
    renderDate(id) {
        const { begin_date, end_date } = this.state;
        const selected = id === 'begin_date' ? begin_date : end_date;
        const label = titleize(humanize(id));
        const dateClass = classnames({
            'md:w-3/4': true,
        });
        return (React.createElement("div", { className: dateClass, key: id },
            React.createElement("label", { className: "block mb-2 form-label" }, label),
            React.createElement("div", { className: "flex justify-between mr-2" },
                React.createElement(DatePicker, { selected: selected, className: "w-auto form-field", placeholderText: label, dateFormat: DATE_FORMAT, onChange: this.handleDateTimeSelect(id), isClearable: true, onSelect: this.handleDateTimeSelect(id), key: id, shouldCloseOnSelect: true, showTimeSelect: true, timeIntervals: 5 }))));
    }
    renderDateRange() {
        return (React.createElement("div", { className: "flex justify-between", key: "date-range" },
            this.renderDate('begin_date'),
            this.renderDate('end_date')));
    }
    renderInput(id) {
        const { t } = this.props;
        const key = `${id}_input`;
        return (React.createElement("div", { className: "md:w-1/2 md:mr-2" },
            React.createElement(CargomaticInput, { key: key, type: "text", className: "w-full form-field", value: this.state.custom_description, label: t('DESCRIPTION', { count: 1 }), placeholder: t('CUSTOM_DESCRIPTION'), onChange: (value) => this.handleFieldChange('custom_description', value) })));
    }
    renderLocationSelector() {
        const { t } = this.props;
        const { error } = this.state;
        const locations = [
            {
                value: 'Customer',
                localizationSlug: 'CUSTOMER',
            },
            {
                value: 'Terminal',
                localizationSlug: 'TERMINAL',
            },
        ];
        const locationClass = classnames({
            'md:w-1/2': true,
            'mr-2': true,
            'mb-4': true,
            error: error.hasOwnProperty('location'),
        });
        return (React.createElement("div", { className: locationClass, key: "location" },
            React.createElement(CargomaticSelect, { label: t('LOCATION'), textKey: "localizationSlug", valueKey: "value", items: locations, onSelect: (selected) => this.handleFieldChange('location', selected), value: this.state.location, className: "form-control", showCaption: true })));
    }
    renderWaitTimeFields() {
        return (React.createElement("div", null,
            this.renderLocationSelector(),
            this.renderDateRange()));
    }
    renderAccessorialSpecificFields() {
        const DATE_RANGE_ACCESSORIALS = [
            'chassis',
            'storage',
            'demurrage',
            'tri_axle',
        ];
        const { type } = this.state;
        if (type === '' || type === 'other')
            return null;
        switch (type) {
            case 'wait_time':
                return this.renderWaitTimeFields();
            case 'pre_pull':
            case 'per_diem':
            case 'stop_off':
                return this.renderDate('begin_date');
            case 'tolls':
            case 'chassis_split':
            case 'pier_pass':
            case 'gate_fee':
                return this.renderInput(type);
            default:
                return ((DATE_RANGE_ACCESSORIALS.includes(type) && this.renderDateRange()) ||
                    null);
        }
    }
    getTotal() {
        const { shipper_cost, shipper_unit_qty } = this.state;
        const total = (shipper_cost || 0) * (shipper_unit_qty || 1);
        return total;
    }
    renderRequiredFields(accessorial) {
        const { t } = this.props;
        const { location, begin_date, description, end_date, errors } = this.state;
        const locationTypes = [
            {
                value: 'customer',
                localizationSlug: 'CUSTOMER',
            },
            {
                value: 'terminal',
                localizationSlug: 'TERMINAL',
            },
        ];
        if (!accessorial) {
            return null;
        }
        if (!accessorial.begin_date_required &&
            !accessorial.description_required &&
            !accessorial.end_date_required &&
            !accessorial.location_required) {
            return null;
        }
        return (React.createElement("div", { className: "flex" },
            accessorial.begin_date_required && (React.createElement("div", { className: "px-2" },
                React.createElement("label", { htmlFor: "startDate", className: "block mb-2 form-label" }, t('BEGIN_DATE')),
                React.createElement(DatePicker, { id: "beginDate", selected: getMomentDate(begin_date), onChange: this.handleDateValueChange('begin_date'), customInput: React.createElement(DateIconButton, null), dateFormat: DATE_FORMAT, shouldCloseOnSelect: true, showTimeSelect: true, timeIntervals: 5 }))),
            accessorial.end_date_required && (React.createElement("div", { className: "px-2" },
                React.createElement("label", { htmlFor: "endDate", className: "block mb-2 form-label" }, t('END_DATE')),
                React.createElement(DatePicker, { id: "startDate", selected: getMomentDate(end_date), onChange: this.handleDateValueChange('end_date'), customInput: React.createElement(DateIconButton, null), dateFormat: DATE_FORMAT, shouldCloseOnSelect: true, showTimeSelect: true, timeIntervals: 5 }))),
            accessorial.location_required && (React.createElement("div", { className: "px-2" },
                React.createElement(CargomaticSelect, { selected: location, fullWidth: false, items: locationTypes, valueKey: "value", textKey: "localizationSlug", error: errors.location, defaultSelectLabel: "", label: t('LOCATION'), info: t('LOCATION_CUSTOMER_OR_TERMINAL'), onSelect: this.handleLocationChange, showCaption: true }))),
            accessorial.description_required && (React.createElement("div", { className: "md:w-1/2" },
                React.createElement(CargomaticInput, { value: description, type: "text", label: t('DESCRIPTION', { count: 1 }), placeholder: t('ENTER_ACCESSORIAL_DESCRIPTION'), onChange: this.handleValueChange('description') })))));
    }
    renderNotesInput() {
        const { t } = this.props;
        const { note } = this.state;
        return (React.createElement("div", { style: { minWidth: '250px' } },
            React.createElement(CargomaticInput, { maxLength: 300, className: "mb-4", type: "text", placeholder: titleize(t('NOTE', { count: 3 })), label: titleize(t('NOTE', { count: 3 })), onChange: this.handleNotesField, value: note })));
    }
    renderAccessorialCostAdjustment(payerCostClassName, payeeCostClassName) {
        const { t } = this.props;
        const { name, errors, type, shipper_cost, carrier_cost, isAdjustment, existing, adjustmentReasonCode, value, } = this.state;
        const costClassName = type === PAYER_COST_FIELD_NAME ? payerCostClassName : payeeCostClassName;
        let inputTypeField;
        switch (type) {
            case 'carrier_cost':
                inputTypeField = 'carrier_cost';
                break;
            case FSC_TYPE:
                inputTypeField = 'value';
                break;
            default:
                inputTypeField = 'shipper_cost';
                break;
        }
        let costValue;
        switch (type) {
            case PAYER_COST_FIELD_NAME:
                costValue = shipper_cost;
                break;
            case BASE_COST:
                costValue = shipper_cost;
                break;
            default:
                costValue = carrier_cost;
                break;
        }
        return (React.createElement("div", null,
            React.createElement("div", { className: "flex" },
                React.createElement("div", { className: "md:w-1/2" },
                    React.createElement(CargomaticInput, { className: "md:mr-2 mb-4", value: t(sluggify(name)), error: errors.accessorialName, label: t('ACCESSORIAL_NAME'), disabled: true, info: t('ACCESSORIAL_NAME_INFO'), onChange: this.handleNameChange, name: inputTypeField + 'AccessorialName' })),
                React.createElement("div", { className: "md:w-1/2" },
                    React.createElement("fieldset", { className: costClassName },
                        React.createElement(CargomaticInput, { placeholder: isAdjustment ? t('ADJUSTED_AMOUNT') : t('RATE', { count: 1 }), label: isAdjustment ? t('ADJUSTED_AMOUNT') : t('RATE', { count: 1 }), info: t('INTENDED_VALUE_POST_ADJUSTMENT'), onChange: (value) => this.handleFieldChange(inputTypeField, value), maxLength: 5, type: "number", value: type === FSC_TYPE ? value : costValue, name: inputTypeField + 'AdjustedAmount' })))),
            React.createElement("div", { className: "" }, existing && (React.createElement(CargomaticInput, { className: "mb-4", value: adjustmentReasonCode, error: errors.adjustmentReason, label: t('ADJUSTMENT_REASON'), info: t('ADJUSTMENT_REASON_INFO'), placeholder: t('ADJUSTMENT_REASON'), onChange: this.handleAdjustmentReason, name: inputTypeField + 'AdjustmentReason' }))),
            React.createElement("div", { className: "flex" },
                React.createElement("fieldset", { className: "w-full" }, this.renderAccessorialSpecificFields())),
            this.renderAccessorialFscAdjustment(costClassName)));
    }
    renderAccessorialFscAdjustment(costClassName) {
        const { t } = this.props;
        const { errors, fscError, existingFsc, fscAdjustmentReason } = this.state;
        const inputTypeField = 'value';
        return (React.createElement(React.Fragment, null,
            this.renderErrors(fscError),
            existingFsc && (React.createElement("div", { className: "border-t-2" },
                React.createElement(Alert, { className: "my-4", type: "info" }, t('PLEASE_ADJUST_FSC')),
                React.createElement("div", { className: "flex" },
                    React.createElement("div", { className: "md:w-1/2" },
                        React.createElement(CargomaticInput, { className: "md:mr-2 mb-4", value: existingFsc.message, label: t('ACCESSORIAL_NAME'), disabled: true, info: t('ACCESSORIAL_NAME_INFO'), onChange: () => { }, name: inputTypeField + 'AccessorialName' })),
                    React.createElement("div", { className: "md:w-1/2" },
                        React.createElement("fieldset", { className: costClassName },
                            React.createElement(CargomaticInput, { placeholder: t('ADJUSTED_AMOUNT'), label: t('ADJUSTED_AMOUNT'), info: t('INTENDED_VALUE_POST_ADJUSTMENT'), onChange: (value) => this.handleFscValueChange(value), maxLength: 5, type: "number", value: existingFsc.value, name: inputTypeField + 'AdjustedAmount' })))),
                React.createElement("div", { className: "" },
                    React.createElement(CargomaticInput, { className: "mb-4", value: fscAdjustmentReason, error: errors.fscAdjustmentReason, label: t('ADJUSTMENT_REASON'), info: t('ADJUSTMENT_REASON_INFO'), placeholder: t('ADJUSTMENT_REASON'), onChange: this.handleFscAdjustmentReason, name: inputTypeField + 'AdjustmentReason' }))))));
    }
    renderAccessorialAddition(payerCostClassName, payeeCostClassName) {
        var _a, _b;
        const { error, errors, payer_type, payee_type, name, vendor_name, partner_name, existing, shipper_cost, shipper_unit_qty, carrier_cost, carrier_unit_qty, adjustmentReasonCode, } = this.state;
        const { shipment, t } = this.props;
        // const shipper = shipment?.shipper;
        const carrier = shipment === null || shipment === void 0 ? void 0 : shipment.carrier;
        const consignee = shipment === null || shipment === void 0 ? void 0 : shipment.consignee;
        return (React.createElement("div", null,
            React.createElement("div", { className: "grid grid-cols-3 gap-4" },
                React.createElement("div", { className: "" },
                    React.createElement(CargomaticInput, { className: "mb-4", value: name, error: errors.accessorialName, label: t('ACCESSORIAL_NAME'), disabled: true, info: t('ACCESSORIAL_NAME_INFO'), onChange: this.handleNameChange })),
                React.createElement("div", { className: "" },
                    React.createElement("label", { className: "form-label mb-1" }, t('PAYER_TYPE')),
                    React.createElement(CargomaticRadio, { id: "shipper", name: "payer_type", className: "mb-2", value: SHIPPER, checked: isShipper(payer_type), onChange: this.handlePayerTypeChange }, titleize(t('SHIPPER', { count: 1 }))),
                    React.createElement(CargomaticRadio, { id: "consignee", name: "payer_type", value: CONSIGNEE, checked: isConsignee(payer_type), onChange: this.handlePayerTypeChange, disabled: !consignee, info: !consignee ? t('CONSIGNEE_ACCESSORIAL_ERROR') : '' }, titleize(t('CONSIGNEE', { count: 1 })))),
                React.createElement("div", { className: "" },
                    React.createElement("label", { className: "form-label mb-1" }, t('PAYEE_TYPE')),
                    React.createElement(CargomaticRadio, { id: "carrier", name: "payee_type", className: "mb-2", value: CARRIER, checked: isCarrier(payee_type), onChange: this.handlePayeeTypeChange, disabled: !carrier, info: !carrier ? t('CARRIER_ACCESSORIAL_ERROR') : '' }, titleize(t('CARRIER', { count: 1 }))),
                    React.createElement(CargomaticRadio, { id: "vendor", name: "payee_type", value: VENDOR, checked: isVendor(payee_type), onChange: this.handlePayeeTypeChange }, titleize(t('VENDOR', { count: 1 }))),
                    React.createElement(CargomaticRadio, { id: "partner", name: "payee_type", value: PARTNER, checked: isPartner(payee_type), onChange: this.handlePayeeTypeChange }, t('PARTNER'))),
                isPartner(payee_type) && (React.createElement("div", null,
                    React.createElement("label", { className: "form-label mb-1" }, t('PARTNER')),
                    React.createElement(CustomerSearchV2, { id: "customer-search-input-partner", clearOnSelect: false, onChange: this.handlePartnerFieldChange, onSelect: this.handlePartnerSelect, placeholder: t('SEARCH_FOR_PAYMENT_PARTNERS'), searchField: "name", type: "partners", searchCustomers: findPaymentPartners, authorizedOnly: false, value: partner_name }))),
                isVendor(payee_type) && (React.createElement("div", { className: "" },
                    React.createElement("label", { className: "mb-1 form-label" }, t('SEARCH_VENDORS')),
                    React.createElement(CustomerSearch, { clearOnSelect: false, onChange: this.handleVendorFieldChange, onSelect: this.handleVendorSelect, placeholder: t('SEARCH_VENDORS_PLACEHOLDER'), type: "vendors", authorizedOnly: false, value: vendor_name }))),
                React.createElement("div", { className: "" }, existing && (React.createElement(CargomaticInput, { className: "mb-4", value: adjustmentReasonCode, error: errors.adjustmentReason, label: t('ADJUSTMENT_REASON'), info: t('ADJUSTMENT_REASON_INFO'), onChange: this.handleAdjustmentReason })))),
            React.createElement("hr", { className: "my-2" }),
            React.createElement("div", { className: "grid grid-cols-3 gap-4" },
                React.createElement("div", { className: "" },
                    React.createElement("fieldset", { className: payerCostClassName },
                        React.createElement(CargomaticInput, { type: "number", placeholder: t('PAYER_RATE_PER_UNIT'), value: shipper_cost, disabled: this.isPayerCostDisabled(), label: t('PAYER_RATE_PER_UNIT'), onChange: (value) => this.handleFieldChange(PAYER_COST_FIELD_NAME, value) }))),
                React.createElement("div", { className: "" },
                    React.createElement(CargomaticInput, { className: "mb-4", value: shipper_unit_qty, error: error.shipper_unit_qty, label: t('PAYER_UNITS'), info: t('PAYER_UNITS_INFO'), onChange: this.handlePayerUnitsField }))),
            React.createElement("hr", { className: "my-2" }),
            React.createElement("div", { className: "grid grid-cols-3 gap-4" },
                React.createElement("div", { className: "" },
                    React.createElement("fieldset", { className: payeeCostClassName },
                        React.createElement(CargomaticInput, { type: "number", placeholder: t('PAYEE_RATE_PER_UNIT'), value: carrier_cost, disabled: this.isPayeeCostDisabled(), label: t('PAYEE_RATE_PER_UNIT'), onChange: (value) => this.handleFieldChange(PAYEE_COST_FIELD_NAME, value) }))),
                React.createElement("div", { className: "" },
                    React.createElement(CargomaticInput, { className: "mb-4", value: carrier_unit_qty, error: error.carrier_unit_qty, label: t('PAYEE_UNITS'), info: t('PAYEE_UNITS_AMOUNT'), onChange: this.handlePayeeUnitsField }))),
            React.createElement("hr", { className: "my-2" }),
            this.state.accessorial && featureEnabled(CONFIGURED_FEATURES.SSR) && (React.createElement(ViewAccessorialRequestDocumentRequirements, { containerClassName: "mb-4 p-2", accessorial: this.state.accessorial, shipper: (_b = (_a = this.props.shipment) === null || _a === void 0 ? void 0 : _a.shipper) === null || _b === void 0 ? void 0 : _b._id, shipment: this.props.shipment, handleDocumentUploading: this.handleProcessingDocumentUpload, handleCustomerApprovalChanges: this.handleCustomerApprovalChanges, handleUpdateAccessorialRequiredDocs: this.handleUpdateAccessorialRequiredDocs, isExistingAccessorialRequest: this.state.isAdjustment })),
            this.state.accessorial && featureEnabled(CONFIGURED_FEATURES.SSR) && (React.createElement("hr", { className: "my-2" })),
            React.createElement("div", { className: "flex" },
                React.createElement("div", { className: "md:w-1" }, this.renderNotesInput())),
            this.renderRequiredFields(this.state.accessorial)));
    }
    render() {
        var _a;
        const { error, isAdjustment } = this.state;
        const { customAdjustment, t } = this.props;
        const adjustmentIsProcessed = customAdjustment && customAdjustment.processed;
        const renderRemoveButton = this.renderRemoveButton();
        const nameClassName = classnames({
            'md:mr-2': true,
            'mb-4': true,
            error: error.hasOwnProperty('name'),
        });
        const equipmentClassName = classnames({
            'mb-4': true,
            error: error.hasOwnProperty('equipment'),
        });
        const footerClassName = classnames({
            flex: true,
            'justify-end': adjustmentIsProcessed || isAdjustment,
        });
        const payerCostClassName = classnames({
            'md:mr-2': true,
            'mb-4': true,
            error: error.hasOwnProperty(PAYER_COST_FIELD_NAME),
        });
        const payeeCostClassName = classnames({
            'md:mr-2': true,
            'mb-4': true,
            error: error.hasOwnProperty(PAYEE_COST_FIELD_NAME),
        });
        const modalTitle = isAdjustment
            ? t('ADJUST_DRAYAGE_ACCESSORIAL')
            : t('ADD_DRAYAGE_ACCESSORIAL');
        return (React.createElement(CargomaticModal, { show: this.props.show, onHide: this.handleClose, onEntered: this.fetchAccessorials, keyboard: false, backdrop: "static", title: t(modalTitle), footer: React.createElement(Footer, { footerClassName: footerClassName, onRemove: this.handleRemoveAdjustment, showRemove: renderRemoveButton && isAdjustment, showSave: isAdjustment, saveDisabled: this.isSaveButtonDisabled(), total: this.getTotal(), showTotal: !isAdjustment, currency: (_a = this.props.shipment) === null || _a === void 0 ? void 0 : _a.currency, onSave: isAdjustment
                    ? this.handleSave
                    : this.handleCreateAccessorialRequest, onCancel: this.handleClose }) },
            this.renderErrors(error),
            this.renderAdjustmentWarning(),
            React.createElement("div", { className: "flex" },
                !this.state.isAdjustment && (React.createElement("div", { className: "md:w-1/2" },
                    React.createElement("fieldset", { className: nameClassName },
                        React.createElement("label", { className: "block mb-2 form-label" }, t('NAME')),
                        this.renderDropdown()))),
                React.createElement("div", { className: "md:w-1/2" },
                    React.createElement("fieldset", { className: equipmentClassName },
                        React.createElement("label", { className: "block mb-2 form-label" }, t('EQUIPMENT')),
                        React.createElement("select", { className: "form-select", value: this.state.equipment, disabled: this.props.customAdjustment &&
                                this.props.customAdjustment.equipment, onChange: (e) => this.handleFieldChange('equipment', e.target.value) },
                            React.createElement("option", { value: "" }, t('SELECT_EQUIPMENT')),
                            this.props.equipment.map((equipment) => (React.createElement("option", { key: equipment._id, value: equipment._id }, getEquipmentLabel(equipment)))))))),
            React.createElement("div", null,
                isAdjustment &&
                    this.renderAccessorialCostAdjustment(payerCostClassName, payeeCostClassName),
                !isAdjustment &&
                    this.renderAccessorialAddition(payerCostClassName, payeeCostClassName))));
    }
}
AddOrAdjustDrayageAccessorialModal.propTypes = {
    show: PropTypes.bool,
    equipment: PropTypes.arrayOf(PropTypes.shape({
        _id: PropTypes.string,
        equipment_id: PropTypes.string,
    })),
    shipment: PropTypes.object,
    customAdjustment: PropTypes.shape({
        type: PropTypes.string,
        message: PropTypes.string,
        value: PropTypes.number,
        equipment: PropTypes.string,
    }),
    onHide: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired,
    onRemoveAdjustment: PropTypes.func.isRequired,
    onEditAdjustment: PropTypes.func.isRequired,
};
AddOrAdjustDrayageAccessorialModal.defaultProps = {
    show: false,
    equipment: [],
};
function getEquipmentLabel(equipment) {
    return `${equipment.equipment_id}`;
}
const combineDateTime = (date, time) => {
    const dateObj = moment.isMoment(date) ? date : moment(date);
    const timeObj = moment.isMoment(time) ? time : moment(time);
    const combined = dateObj.set({
        hour: timeObj.get('hour'),
        minute: timeObj.get('minute'),
    });
    return combined;
};
const DATE_RANGE_FIELDS = [
    'chassis',
    'storage',
    'demurrage',
    'wait_time',
    'pre_pull',
    'per_diem',
];
const DESCRIPTION_FIELDS = ['tolls', 'chassis_split', 'pier_pass', 'stop_off'];
const PAYER_COST_LABEL = 'Payer Cost';
const PAYEE_COST_LABEL = 'Payee Cost';
const getCostLabel = (message, ledger) => {
    if (ledger === RECEIVABLES && message.includes(PAYEE_COST_LABEL)) {
        return message.replace(PAYEE_COST_LABEL, PAYER_COST_LABEL);
    }
    if (ledger === PAYABLES && message.includes(PAYER_COST_LABEL)) {
        return message.replace(PAYER_COST_LABEL, PAYEE_COST_LABEL);
    }
    return message;
};
const generateCustomAdjustmentMessage = (adjustment) => {
    let date = null;
    const DATETIME_FORMAT = 'MM-DD-YYYY hh:mm A';
    const dateFormat = 'MM-DD-YYYY';
    const { message } = adjustment;
    if (DATE_RANGE_FIELDS.includes(adjustment.type)) {
        if (adjustment.begin_date && adjustment.end_date) {
            const begin = adjustment.begin_date && adjustment.begin_time
                ? combineDateTime(adjustment.begin_date, adjustment.begin_time).format(DATETIME_FORMAT)
                : moment(adjustment.begin_date).format(dateFormat);
            const end = adjustment.end_date && adjustment.end_time
                ? combineDateTime(adjustment.end_date, adjustment.end_time).format(DATETIME_FORMAT)
                : moment(adjustment.end_date).format(dateFormat);
            if (adjustment.location) {
                return `${message} (${adjustment.location} - ${begin} - ${end})`;
            }
            return `${message} (${begin} - ${end})`;
        }
        if (adjustment.begin_date) {
            date = adjustment.begin_time
                ? combineDateTime(adjustment.begin_date, adjustment.begin_time).format(DATETIME_FORMAT)
                : moment(adjustment.begin_date).format(dateFormat);
        }
        else if (adjustment.end_date) {
            date = adjustment.end_time
                ? combineDateTime(adjustment.end_date, adjustment.end_time).format(DATETIME_FORMAT)
                : moment(adjustment.end_date).format(dateFormat);
        }
        return date ? `${message} (${date})` : message;
    }
    if (DESCRIPTION_FIELDS.includes(adjustment.type)) {
        return adjustment.custom_description
            ? `${message} (${adjustment.custom_description})`
            : message;
    }
    return message;
};
const getCurrentBaseCostTotal = (ledger = [], initialBaseCost = 0) => {
    const baseCostItems = ledger.filter((item) => item.adjusted_item === 'base_cost' &&
        item.category === 'accessorials' &&
        item.processed);
    return baseCostItems.reduce((total, current) => {
        total += current.value;
        return total;
    }, initialBaseCost);
};
const getBaseCostAdjustmentTotal = (baseCost, newValue) => {
    const currentBaseCostValue = parseFloat(baseCost);
    const intendedBaseCostValue = parseFloat(newValue);
    return currentBaseCostValue + intendedBaseCostValue;
};
export default withTranslation()(AddOrAdjustDrayageAccessorialModal);
